export enum AgreementTypeCode {
    Nabat = 1,
    Insurance = 2,
    Prospect = 3,
    OperationalWhatsApp = 10,
    MarketingWhatsApp = 12
}
